module.exports = __webpack_public_path__ + "img/23.b18971a0.jpg";